export default __webpack_public_path__ + "static/Bm_ELIB_EzyMedical_Cont-4f9fef6fc2bbc9f1be1eccc83ca1b8c0.pdf";